import React from 'react'
import styled from 'styled-components'

function Imagen({src, backgroundColor, width}) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Content src={src}  className='animate__animated animate__fadeIn' width={width}></Content>
    </Wrapper>
  )
}

export default Imagen;

const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    width:100%;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-azul-morado)'};
`;

const Content = styled.img`
    max-width:${props=> props.width ? props.width : '55%'};
    padding: 24px;
`;